import { useEffect, type RefObject } from "react";
import { useMap } from "react-leaflet";

/** Enables or disables Leaflet interactions (scroll zoom, drag, touch zoom). */
export function MapInteractionController({ interactive }: { interactive: boolean }) {
  const map = useMap();

  useEffect(() => {
    const enable = () => {
      map.scrollWheelZoom.enable();
      map.dragging.enable();
      map.touchZoom.enable();
      map.doubleClickZoom.enable();
      map.boxZoom.enable();
    };

    const disable = () => {
      map.scrollWheelZoom.disable();
      map.dragging.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.boxZoom.disable();
    };

    if (interactive) {
      enable();
    } else {
      disable();
    }
  }, [interactive, map]);

  return null;
}

export function useMapInteractionLock(
  wrapperRef: RefObject<HTMLDivElement | null>,
  interactive: boolean,
  enabled: boolean,
  onDeactivate: () => void,
) {
  useEffect(() => {
    if (!enabled || !interactive) return;

    const handlePointerDown = (event: PointerEvent) => {
      const wrapper = wrapperRef.current;
      if (wrapper && !wrapper.contains(event.target as Node)) {
        onDeactivate();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [enabled, interactive, onDeactivate, wrapperRef]);
}
